import "./GetQuote.module.css";
import MainNavigation from "@/reusable_sections/Header";
import RequestYourEstimate from "./sections/RequestYourEstimate";
import DirectLine from "./sections/DirectLine";
import SiteFooter from "@/reusable_sections/Footer";
export default function GetQuotePage() {
  return <div>
      <MainNavigation />
      <DirectLine />
      <RequestYourEstimate />
      <SiteFooter />
    </div>;
}